import { useUnlinkConversationFromInsuredMutation } from "@qw/graphql";
import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router";

export const UnlinkInsuredButton = ({
  conversationId,
  rootPath,
  // `outline` where this is a segment of a button group; ghost is right for the
  // lone copy beside the star in merged mode.
  variant = "ghost",
}: {
  conversationId: string;
  rootPath: string;
  variant?: "ghost" | "outline";
}) => {
  const navigate = useNavigate();
  const { insuredId } = useParams();
  const [unlinkInsured] = useUnlinkConversationFromInsuredMutation({
    refetchQueries: ["InboxConversation"],
  });

  const handleUnlinkInsured = useCallback(async () => {
    await unlinkInsured({ variables: { input: { conversationId } } });
    // If we're on an insured-specific route, navigate back to inbox
    // to remove the insuredId URL parameter while preserving conversationId query param
    if (insuredId) {
      navigate({ pathname: rootPath, search: `?conversationId=${conversationId}` }, { replace: true });
    }
  }, [conversationId, unlinkInsured, insuredId, navigate, rootPath]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant={variant}
          size="sm"
          display="icon"
          aria-label="Unlink Insured"
          onClick={handleUnlinkInsured}
          className="group"
        >
          <Icon icon="link" className="group-hover:hidden" />
          <Icon icon="link_off" className="hidden group-hover:inline" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Unlink Insured</TooltipContent>
    </Tooltip>
  );
};
